export default __webpack_public_path__ + "static/media/quotation-1.6ee6ac93.svg";